import { useCallback, useEffect, useState } from "react";

const useScheduledDate = ({ startsAt, endsAt }) => {
  const [countdown, setCountdown] = useState("");

  const formattedDate = useCallback(() => {
    const startDate = new Date(startsAt);
    const dateOptions = { year: "numeric", month: "short", day: "numeric" };
    const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: false };
    const formattedDateString = startDate.toLocaleDateString("en-US", dateOptions);
    const formattedTimeString = startDate.toLocaleTimeString("en-US", timeOptions);
    return `${formattedDateString} at ${formattedTimeString}`;
  }, [startsAt]);

  const endTime = useCallback(() => {
    if (endsAt) {
      const endDate = new Date(endsAt);
      const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: false };
      return endDate.toLocaleTimeString("en-US", timeOptions);
    }
  }, [endsAt]);

  const calculateCountdown = useCallback(() => {
    if (startsAt) {
      const now = new Date();
      const scheduledTime = new Date(startsAt);
      let delta = Math.floor((scheduledTime - now) / 1000);

      if (delta <= 0) return "Time's up!";

      const days = Math.floor(delta / (3600 * 24));
      delta -= days * 3600 * 24;
      const hours = Math.floor(delta / 3600) % 24;
      delta -= hours * 3600;
      const minutes = Math.floor(delta / 60) % 60;
      const seconds = delta % 60;

      let countdownString = "";
      if (days > 0) countdownString += `${days} day${days > 1 ? "s" : ""} `;
      countdownString += `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")} Remaining`;

      return countdownString.trim();
    }
  }, [startsAt]);

  useEffect(() => {
    const interval = setInterval(() => {
      const countdownString = calculateCountdown();
      setCountdown(countdownString);
    }, 1000);

    return () => clearInterval(interval);
  }, [calculateCountdown]);

  return { formattedDate, endTime, countdown };
};

export default useScheduledDate;
